<template>
    <div class="page flex-col">
        <SideBar ref="sidebarRef" class="hidden-sidebar" />
        <div class="main-container">
            <!-- 修改后的主内容区 -->
            <div class="content-body">
                <div class="search-bar">
                    <input type="text" class="search-input" placeholder="搜索历史面试记录" v-model="searchQuery"
                        @keyup.enter="handleSearch">
                    <div class="search-icon-container" @click="handleSearch">
                        <div class="search-icon">
                            <img src="./assets/img/search.png" class="search-icon-img" alt="搜索图标" />
                        </div>
                    </div>
                </div>

                <div v-if="loading" class="loading-indicator">
                    <span style="font-size: 1.2vw;color: #999;">加载中...</span>
                </div>

                <div v-else-if="historyItems.length === 0" class="no-data">
                    <span style="font-size: 1.2vw;color: #999;">暂无面试记录</span>
                </div>

                <div class="history-cards">
                    <div class="history-card" v-for="(item, index) in filteredHistoryItems" :key="index"
                        @click="viewHistory(item)" @mouseover="hoveredCard = item.id" @mouseleave="hoveredCard = null">
                        <!-- 卡片标题与编辑功能 -->
                        <div class="card-header">
                            <div class="card-title" v-if="!editingCard || editingCard !== item.id">
                                {{ item.name }}
                                <div class="edit-icon" v-if="hoveredCard === item.id" @click.stop="startEditing(item)">
                                    <img src="./assets/img/edit-icon.png" alt="编辑" />
                                </div>
                            </div>
                            <div class="card-title-edit" v-else>
                                <input type="text" v-model="editingName" @keyup.enter="saveEditing(item)"
                                    @blur="saveEditing(item)" ref="editInput" @click.stop />
                            </div>
                        </div>

                        <div class="card-date">{{ formatDate(item.time) }}</div>
                        <div class="card-text">{{item.positionName}}</div>
                        <div class="card-tag"></div>
                        <SlidableRing style="position: absolute; left: 7.5vw; top: 3vh; scale: 1.5;"
                            >
                            <div class="score-inner"
                                style="position: absolute; left: 15px; top: 15px; width: 30px; height: 30px;">
                                <div class="score-value">{{ item.score }}</div>
                                <div class="score-label">得分</div>
                            </div>
                        </SlidableRing>

                        <!-- 删除图标 -->
                        <div class="delete-icon" v-if="hoveredCard === item.id" @click.stop="deleteCard(item.id)">
                            <img src="./assets/img/trash-icon.png" alt="删除" />
                        </div>
                    </div>
                </div>

                <!-- 分页控件 -->
                <div v-if="historyItems.length > 0 && !loading" class="pagination-container">
                    <button 
                        class="page-btn prev-btn" 
                        @click="changePage(pagination.page_no - 1)"
                        :disabled="pagination.page_no <= 1"
                    >
                        上一页
                    </button>
                    
                    <div class="page-numbers">
                        <button 
                            v-for="page in visiblePages" 
                            :key="page"
                            class="page-number"
                            :class="{ 'active': page === pagination.page_no }"
                            @click="changePage(page)"
                        >
                            {{ page }}
                        </button>
                        
                        <span v-if="showEllipsisBefore" class="ellipsis">...</span>
                        
                        <button 
                            v-if="totalPages > 1"
                            class="page-number"
                            :class="{ 'active': pagination.page_no === totalPages }"
                            @click="changePage(totalPages)"
                        >
                            {{ totalPages }}
                        </button>
                    </div>
                    
                    <button 
                        class="page-btn next-btn" 
                        @click="changePage(pagination.page_no + 1)"
                        :disabled="pagination.page_no >= totalPages"
                    >
                        下一页
                    </button>

                    <!-- 页码输入 -->
                    <div class="page-jump">
                        <span>前往</span>
                        <input 
                            type="number" 
                            v-model="jumpPage" 
                            min="1" 
                            :max="totalPages"
                            @keyup.enter="handleJump"
                            @blur="handleJump"
                            class="page-input"
                        >
                        <span>页</span>
                        <button class="jump-btn" @click="handleJump">确定</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 模态框组件 -->
        <div class="modal-overlay" v-if="isModalVisible" @click.self="cancelModal">
            <div class="modal-container">
                <!-- 编辑名称模态框 -->
                <div v-if="modalType === 'edit'" class="modal-content">
                    <div class="modal-title">修改名称</div>
                    <input type="text" class="modal-input" v-model="editingName" ref="modalEditInput"
                        placeholder="请输入新名称" />
                    <div class="modal-buttons">
                        <button class="modal-btn confirm-btn" @click="confirmEdit">确定</button>
                        <button class="modal-btn cancel-btn" @click="cancelModal">取消</button>
                    </div>
                </div>

                <!-- 删除确认模态框 -->
                <div v-if="modalType === 'delete'" class="modal-content">
                    <div class="modal-title">您确定要删除吗？</div>
                    <div class="modal-buttons">
                        <button class="modal-btn confirm-btn" @click="confirmDelete">确定</button>
                        <button class="modal-btn cancel-btn" @click="cancelModal">取消</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 在底部添加UserProfileEditor组件 -->
        <user-profile-editor :visible.sync="showProfileEditor" :user-info="userInfo" @submit="handleProfileSubmit"
            @cancel="handleProfileCancel" @avatar-updated="handleAvatarUpdate" />
    </div>
</template>


<script>
import { getInterviewData } from '@/api/mianshilishi.js'
import { mapState } from 'vuex'
import SideBar from '@/components/SideBar/index.vue';
import SlidableRing from '@/components/SlidableRing/index.vue'
import UserProfileEditor from '@/components/UserProfileEditor/index.vue';
import { getUserInterviewList, deleteUserInterview, updateUserInterview, addUserInterview } from '@/api/mianshilishi.js' // 引入API函数
import { test_uesrinfo } from '@/api/user'
import { getToken } from '@/store/local/auth'



export default {
    components: {
        SlidableRing,
        SideBar,
        UserProfileEditor
    },
    data() {
        return {
            historyItems: [], // 改为空数组，将从API获取
            searchQuery: '',
            hoveredCard: null,
            editingCard: null,
            editingName: '',
            username: '',
            // 模态框相关状态
            isModalVisible: false,
            modalType: null,
            editingItemId: null,
            deleteItemId: null,

            // 分页相关
            loading: false,
            pagination: {
                page_no: 1,//当前页码
                page_size: 12,//每页显示条数
                total: 0//总条数（从API获取）
            },
            jumpPage: 1, // 用于页码跳转输入框

            // 添加编辑资料相关的数据
            showProfileEditor: false,
            userInfo: {
                avatar: '',
                name: '',
                email: '',
                phone: '',
                wechat: ''
            }
        };
    },
    computed: {
        ...mapState('user', ['avatar']),
        filteredHistoryItems() {
            if (!this.searchQuery) return this.historyItems;
            return this.historyItems.filter(item =>
                item.name && item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
        // 计算总页数
        totalPages() {
            return Math.ceil(this.pagination.total / this.pagination.page_size) || 1;
        },
        // 计算可见页码（最多显示5个连续页码）
        visiblePages() {
            const pages = [];
            const current = this.pagination.page_no;
            const total = this.totalPages;

            // 总页数小于等于5时，显示所有页码
            if (total <= 5) {
                for (let i = 1; i <= total; i++) {
                    pages.push(i);
                }
                return pages;
            }

            // 总页数大于5时，显示当前页附近的页码
            if (current <= 3) {
                return [1, 2, 3, 4, 5];
            } else if (current >= total - 2) {
                return [total - 4, total - 3, total - 2, total - 1, total];
            } else {
                return [current - 2, current - 1, current, current + 1, current + 2];
            }
        },
        // 是否显示前省略号
        showEllipsisBefore() {
            return this.totalPages > 5 && this.pagination.page_no > 3;
        }
    },
    watch: {
        // 监听当前页码变化，同步更新跳转输入框
        'pagination.page_no'(newVal) {
            this.jumpPage = newVal;
        },
        // 监听总页数变化，确保当前页不超过总页数
        totalPages(newVal) {
            if (this.pagination.page_no > newVal && newVal > 0) {
                this.changePage(newVal);
            }
        },
        '$route'(to, from) {
            // 如果当前路径是面试历史页面，且来源是分析页面
            if (to.path.includes('interview_mianshilishi') && from.path.includes('Interview_Analysis')) {
                // 使用setTimeout确保路由完成跳转后再刷新
                setTimeout(() => {
                    window.location.reload();
                }, 50);
            }
        }
    },
    created() {
        // 检查是否有有效的token
        if (!getToken()) {
            this.$message.warning('您尚未登录或登录已过期，请重新登录')
            this.$router.push('/store/entry') // 导航到登录页
            return
        }

        this.fetchInterviewList();
        test_uesrinfo().then(response => {
            // 使用nickname，如果为空则使用account
            this.username = response.data.data.nickname || response.data.data.account || '用户'

            // 同样更新userInfo中的name值
            this.userInfo = {
                name: response.data.data.nickname || response.data.data.account || '',
                avatar: response.data.data.avatar || '',
                email: response.data.data.email || '',
                phone: response.data.data.phone || '',
                wechat: response.data.data.wechat || ''
            };
        })
    },
    methods: {
        // 从API获取面试历史列表
        async fetchInterviewList() {
            try {
                if (!getToken()) {
                    this.$message.warning('身份验证已过期，请重新登录')
                    return
                }

                this.loading = true;
                const params = {
                    page_no: this.pagination.page_no,
                    page_size: this.pagination.page_size,
                    ...(this.searchQuery && { interviewName: this.searchQuery })
                };

                // 使用真实API
                const response = await getUserInterviewList(params);

                console.log('API是否成功调用:', response.status === 200 ? '是' : '否');
                console.log('响应数据:', response.data);
                console.log('响应code:', response.data.code);
                console.log('data中的lists:', response.data.data?.lists);

                // 正确访问嵌套数据结构
                if (response.data && response.data.code === 1) {
                    // 确保lists存在
                    const lists = response.data.data?.lists || [];

                    console.log('找到的记录数量:', lists.length);

                    // 转换API返回的数据格式
                    this.historyItems = lists.map(item => ({
                        id: item.id,
                        name: item.interview_name || '未命名',
                        time: item.create_time,
                        score: item.overall_score,
                        positionName: item.interview_position || '岗位名称',
                        interviewId:item.interview_id
                    }));

                    // 更新分页信息
                    this.pagination.total = response.data.data?.count || 0;
                } else {
                    console.error('获取面试历史失败:', response.msg);
                }
            } catch (error) {
                console.error('获取面试历史出错:', error);
            } finally {
                this.loading = false;
            }
        },

        // 根据面试数据计算分数（示例逻辑，根据实际需求调整）
        calculateScore(item) {
            // 假设分数来自其他地方，这里模拟一个随机分数
            return Math.floor(Math.random() * 31) + 70; // 70-100之间的随机数
        },

        // 搜索处理
        handleSearch() {
            this.pagination.page_no = 1; // 重置到第一页
            this.fetchInterviewList();
        },

        // 分页相关方法
        changePage(page) {
            // 验证页码有效性
            if (page < 1 || page > this.totalPages || page === this.pagination.page_no) {
                return;
            }
            
            this.pagination.page_no = page;
            this.fetchInterviewList();
        },

        // 处理页码跳转
        handleJump() {
            let page = parseInt(this.jumpPage, 10);
            // 验证输入有效性
            if (isNaN(page) || page < 1 || page > this.totalPages) {
                this.jumpPage = this.pagination.page_no;
                return;
            }
            
            this.changePage(page);
        },

        // 修改确认编辑的方法
        async confirmEdit() {
            if (this.editingName.trim()) {
                try {
                    console.log('修改面试记录id：', this.editingItemId)
                    // 正确调用方式，传递id和name两个参数
                    const response = await updateUserInterview(
                        this.editingItemId,
                        this.editingName
                    );
                    console.log('修改面试记录响应：', response)
                    // 更新本地数据
                    const index = this.historyItems.findIndex(i => i.id === this.editingItemId);
                    if (index !== -1) {
                        this.historyItems[index].name = this.editingName.trim();
                    }

                    this.$message.success('修改成功');
                } catch (error) {
                    console.error('修改面试名称失败:', error);
                    this.$message.error('修改失败，请重试');
                }
            }
            this.cancelModal();
        },

        async getInterviewData(id) {
            const response = await getInterviewData(id);
            console.log('获取面试数据响应：', response)
        },
        // 修改确认删除的方法
        async confirmDelete() {
            try {
                console.log('删除面试记录id：', this.deleteItemId)
                // 这里应该有一个删除面试记录的API调用
                const response = await deleteUserInterview(this.deleteItemId);
                console.log('删除面试记录响应：', response)
                // 更新本地数据
                this.historyItems = this.historyItems.filter(item => item.id !== this.deleteItemId);
                // 如果删除后当前页没有数据且不是第一页，则返回上一页
                if (this.historyItems.length === 0 && this.pagination.page_no > 1) {
                    this.changePage(this.pagination.page_no - 1);
                } else {
                    // 刷新当前页数据
                    this.fetchInterviewList();
                }

                this.$message.success('删除成功');
            } catch (error) {
                console.error('删除面试记录失败:', error);
                this.$message.error('删除失败，请重试');
            }
            this.cancelModal();
        },
        formatDate(dateString) {
            if (!dateString) return ''; // 处理空字符串或 null

            try {
                const originalDate = new Date(dateString);

                // 检查日期是否有效
                if (isNaN(originalDate.getTime())) {
                    console.error("无效的日期字符串:", dateString);
                    return "无效日期";
                }



                // 创建一个新的Date对象，时间戳加上8小时
                const adjustedDate = new Date(originalDate.getTime() );

                // 格式化调整后的日期
                const year = adjustedDate.getFullYear();
                const month = String(adjustedDate.getMonth() + 1).padStart(2, '0');
                const day = String(adjustedDate.getDate()).padStart(2, '0');

                // 移除时间部分的格式化
                return `${year}/${month}/${day}`;
            } catch (error) {
                console.error("格式化日期时出错:", error, "日期字符串:", dateString);
                return "日期错误"; // 返回错误提示
            }
        },
        goToHome() {
            this.$router.push('/store/dashboard/profile');
        },
        editProfile() {
            this.showProfileEditor = true;
        },
        feedback() {
            // 调用SideBar组件的openFeedbackModal方法
            this.$refs.sidebarRef.openFeedbackModal();
        },
        logout() {
            // 通过Vuex触发登出操作
            this.$store.dispatch('user/logout').then(() => {
                this.$message.success('已成功退出登录');
                // 重定向到登录页面
                this.$router.push('/store/entry');
            }).catch(error => {
                console.error('退出登录失败:', error);
                this.$message.error('退出登录失败，请重试');
            });
        },
        viewHistory(item) {
            if (!this.editingCard) {
                
                
                // 方案1：使用查询参数而不是路径参数
                this.$router.push({ name: 'Interview_Analysis', params: { id: item.interviewId } })

                // 或者方案2：尝试其他可能的路径格式
                // this.$router.push(`/store/interview_analysis/${item.id}`); // 小写尝试

                // 或者方案3：通过Vuex存储ID，然后跳转到分析页面
                // this.$store.commit('interviewState/SET_CURRENT_INTERVIEW_ID', item.id);
                // this.$router.push('/store/Interview_Analysis');
            }
        },
        startEditing(item) {
            this.editingItemId = item.id;
            this.editingName = item.name;
            this.modalType = 'edit';
            this.isModalVisible = true;

            // 在下一个事件循环中聚焦输入框
            this.$nextTick(() => {
                if (this.$refs.modalEditInput) {
                    this.$refs.modalEditInput.focus();
                }
            });
        },
        saveEditing(item) {
            if (this.editingName.trim()) {
                const index = this.historyItems.findIndex(i => i.id === item.id);
                if (index !== -1) {
                    this.historyItems[index].name = this.editingName.trim();
                }
            }
            this.editingCard = null;
        },
        deleteCard(id) {
            this.deleteItemId = id;
            this.modalType = 'delete';
            this.isModalVisible = true;
        },
        cancelModal() {
            this.isModalVisible = false;
            this.modalType = null;
            this.editingItemId = null;
            this.deleteItemId = null;
        },
        // 添加处理个人资料编辑的方法
        handleProfileSubmit(formData) {
            // 这里可以添加API调用来更新用户资料
            console.log('提交的个人资料:', formData);

            // 更新本地数据
            this.userInfo = { ...this.userInfo, ...formData };
            this.username = formData.name;

            this.$message.success('个人资料更新成功');
            this.showProfileEditor = false;
        },

        handleProfileCancel() {
            this.showProfileEditor = false;
        },

        handleAvatarUpdate(newAvatarUrl) {
            this.userInfo.avatar = newAvatarUrl;
        }
    },
    beforeRouteEnter(to, from, next) {
        // 如果是从分析页面返回，则刷新页面
        if (from.path && from.path.includes('Interview_Analysis')) {
            next(vm => {
                // 等路由完成后刷新页面
                window.location.reload();
            });
        } else {
            next();
        }
    }
};
</script>

<style scoped lang="css" src="./assets/index.response.css" />
<style scoped>
/* 自定义样式 */
.left {
    flex: 0 0 20%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: linear-gradient(180deg, rgba(177, 110, 249, 0.10) 0%, rgba(126, 180, 235, 0.10) 100%);
    border-radius: 26px;
    border: 1px solid #A47FF6;
    box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(27.85px);
    margin-right: -1.5vw;
}

.div42 {
    color: #656587;
    font-family: "Afacad-Regular", sans-serif;
    font-size: 16px;
    font-weight: 400;
    margin-left: 20px;
}

.card-link {
    text-decoration: none;
    color: inherit;
}

.image5 {
    width: 100%;
    height: 60%;
    object-fit: cover;
    border-radius: 25.92px 25.92px 0 0;
}

.frame-1 {
    padding: 20px;
    overflow-y: auto;
    height: calc(100% - 80px);
}

.vector-1 {
    width: 100%;
    height: auto;
}

.div13 {
    color: #656587;
    font-family: "Afacad-Regular", sans-serif;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 10px;
}

.div14 {
    color: #FFFFFF;
    text-align: center;
    font-family: "Afacad-Regular", sans-serif;
    font-size: 13px;
    font-weight: 400;
    text-decoration: none;
    line-height: 32px;
}

._1 {
    position: absolute;
    width: 13vw;
    min-width: 180px;
    max-width: 300px;
    height: auto;
    top: 3vh;
    left: 0;
    z-index: 0;
}

/* 模态框样式 */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-container {
    height: 28vh;
    width: 22vw;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 1vw;
    box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);
    padding: 1.5vw;
    backdrop-filter: blur(15px);
    border: 1px solid rgba(126, 180, 235, 0.3);
}

.modal-content {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.modal-title {
    font-size: 1.2vw;
    color: #444;
    margin-bottom: 1.5vh;
    text-align: center;
}

.modal-input {
    width: 90%;
    height: 3.5vh;
    border: none;
    border-radius: 0.5vw;
    padding: 0 1vw;
    margin-bottom: 2vh;
    font-size: 1vw;
    background: rgba(255, 255, 255, 0.8);
    border-bottom: 2px solid #7EB4EB;
    outline: none;
    text-align: center;
}

.modal-buttons {
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin-top: 8vh;
}

.modal-btn {
    width: 7vw;
    height: 5vh;
    border: none;
    border-radius: 2vh;
    font-size: 0.9vw;
    cursor: pointer;
    transition: all 0.3s;
}

.confirm-btn {
    background: linear-gradient(90deg, #7EB4EB, #B16EF9);
    color: white;
}

.cancel-btn {
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid #ddd;
    color: #666;
}

.modal-btn:hover {
    transform: translateY(-0.2vh);
    box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.1);
}

.user-profile {
    display: flex;
    align-items: center;
    width: 100%;
    padding-left: 2vw;
}

.avatar {
    width: 3.5vw;
    height: 3.5vw;
    min-width: 3.5vw;
    margin-right: 0.1vw;
    border-radius: 50%;
    overflow: hidden;
}

.avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.username {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.history-card {
    border: 1px solid #7EB4EB !important;
    border-image: none !important;
    width: 90%;
}

.sidebar {
    border: none !important;
    border-radius: 0 !important;
    margin-left: 0 !important;
    padding-left: 0 !important;
    width: 20% !important;
    backdrop-filter: blur(27.85px) !important;
}

/* 分页样式 */
.pagination-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2vw 0;
    gap: 1vw;
}

.page-btn {
    padding: 0.5vw 1vw;
    border: none;
    border-radius: 0.5vw;
    background: linear-gradient(90deg, #7EB4EB, #B16EF9);
    color: white;
    cursor: pointer;
    font-size: 0.9vw;
    transition: all 0.3s;
}

.page-btn:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.page-btn:hover:not(:disabled) {
    transform: translateY(-0.2vh);
    box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.1);
}

.page-numbers {
    display: flex;
    align-items: center;
    gap: 0.5vw;
}

.page-number {
    width: 2vw;
    height: 2vw;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.8);
    color: #666;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9vw;
    transition: all 0.3s;
}

.page-number.active {
    background: linear-gradient(90deg, #7EB4EB, #B16EF9);
    color: white;
}

.page-number:hover:not(.active) {
    background: #f0f0f0;
}

.ellipsis {
    color: #999;
    font-size: 1vw;
}

.page-jump {
    display: flex;
    align-items: center;
    gap: 0.5vw;
    margin-left: 1vw;
    color: #666;
    font-size: 0.9vw;
}

.page-input {
    width: 3vw;
    height: 2vw;
    border: 1px solid #ddd;
    border-radius: 0.3vw;
    text-align: center;
    font-size: 0.9vw;
}

.jump-btn {
    padding: 0.3vw 0.8vw;
    border: none;
    border-radius: 0.3vw;
    background: linear-gradient(90deg, #7EB4EB, #B16EF9);
    color: white;
    cursor: pointer;
    font-size: 0.8vw;
    transition: all 0.3s;
}

.jump-btn:hover {
    transform: translateY(-0.1vh);
    box-shadow: 0 0.2vh 0.5vh rgba(0, 0, 0, 0.1);
}
</style>